//
//
//
//
//
//

export default {
props: ['id', 'market', 'uid'],
data() {
  return {
  }
},
computed: {
  sportradarActive() {
    return this.$store.state.sportradarActive
  },
},
filters: {

},
watch: {
  sportradarActive: function (newValue, oldValue) {
      if(newValue && oldValue != newValue) {
          this.init()
      }
  }
},
mounted() {
  if(this.sportradarActive) {
      this.init();
  }
  // this.timestamp = Date.now()
},
methods: {
  init() {
    SIR("addWidget", '.sr-widget-betassist-' + this.uid, "betAssist.standalone", {matchId: this.id, market: this.market});
  }
}
}
